export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9300.23262e7c.jpg";